<template>
  <v-card class="mb-4">
    <v-card-title>Document Vault</v-card-title>
    <v-card-text>
      <div v-for="group in visibleGroups" :key="group.name" class="mb-4">
        <h3 class="mb-2">{{ group.name }}</h3>
        <div
          v-for="entry in visibleEntries(group)"
          :key="entry.type"
          class="entry-row mb-2"
        >
          <strong>{{ entry.displayName }}</strong>
          <DocumentBadges :category="entry" />
          <div
            v-if="entry.documents.length === 0 && !entry.multiInstance"
            class="text-caption text--secondary"
          >
            (not uploaded)
          </div>
          <div
            v-for="document in entry.documents"
            :key="document.id"
            class="ml-3 mt-1"
          >
            <div v-if="document.name" class="text-caption text--secondary">
              {{ document.name }}
            </div>
            <div
              v-if="document.originalLocation"
              class="text-caption text--secondary"
            >
              <strong>Original kept at:</strong> {{ document.originalLocation }}
            </div>
            <div
              v-for="file in document.files"
              :key="file.id"
              class="d-flex align-center"
            >
              <v-icon class="mr-2" small>{{
                iconFor(file.contentType)
              }}</v-icon>
              <span class="flex-grow-1 text-truncate">{{
                file.friendlyFilename
              }}</span>
              <v-btn
                icon
                small
                :loading="downloadingId === file.id"
                @click="download(file)"
              >
                <v-icon small>{{ icons.mdiDownloadOutline }}</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <p v-if="visibleGroups.length === 0" class="mb-0 text--secondary">
        No documents uploaded yet.
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
  import {
    mdiDownloadOutline,
    mdiFilePdfBox,
    mdiFileImage,
    mdiFileDocumentOutline,
  } from '@mdi/js';
  import { CREATE_TESTATOR_DOCUMENT_FILE_PRESIGNED_URL_MUTATION } from '../../../constants/graphql/testator-documents';
  import {
    groupDocumentsByCategory,
    fileIconKey,
  } from '../../../constants/js/testator-documents';
  import DocumentBadges from '../../testator_documents/DocumentBadges.vue';

  const ICON_LOOKUP = { mdiFilePdfBox, mdiFileImage, mdiFileDocumentOutline };

  export default {
    name: 'TestatorDocumentsCard',
    components: { DocumentBadges },
    props: {
      testator: { type: Object, required: true },
    },
    data() {
      return {
        icons: { mdiDownloadOutline },
        downloadingId: null,
      };
    },
    computed: {
      groups() {
        return groupDocumentsByCategory(
          this.testator.testatorDocumentCategories || [],
          this.testator.testatorDocuments || []
        );
      },
      visibleGroups() {
        return this.groups
          .map(g => ({ ...g, entries: this.visibleEntries(g) }))
          .filter(g => g.entries.length > 0);
      },
    },
    methods: {
      visibleEntries(group) {
        return group.entries.filter(entry => {
          if (entry.multiInstance) return entry.documents.length > 0;
          return true;
        });
      },
      iconFor(contentType) {
        return ICON_LOOKUP[fileIconKey(contentType)];
      },
      async download(file) {
        const tab = window.open('', '_blank');
        this.downloadingId = file.id;
        try {
          const { data } = await this.$apollo.mutate({
            mutation: CREATE_TESTATOR_DOCUMENT_FILE_PRESIGNED_URL_MUTATION,
            variables: { id: file.id },
          });
          tab.location.href = data.createTestatorDocumentFilePresignedUrl;
        } finally {
          this.downloadingId = null;
        }
      },
    },
  };
</script>

<style scoped>
  .entry-row {
    border-left: 2px solid #eee;
    padding-left: 10px;
  }
</style>
